import { css } from "@emotion/react"
import { useQuery } from "@tanstack/react-query"
import React, { useEffect, useRef } from "react"

import Image from "@p-ban/common/src/components/html/Image"

import staticSiteApi from "../../../../api/staticSite/staticSiteApi"

import questionIcon from "./img/question.svg"

/**
 * 静的サイトのアンサーちゃんを表示するコンポーネント
 *
 * HTTPリクエストを行い、静的サイトのアンサーちゃんのHTMLを取得して表示しています
 *
 * フロントエンド単体で起動した場合はダミーの画像を表示します
 */
const AnswerChan = () => {
  const ref = useRef<HTMLDivElement>(null)
  const { data } = useQuery(["staticSiteApi.answerChan"], staticSiteApi.answerChan)
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") {
      return
    }
    if (ref.current !== null && data) {
      const doc = new DOMParser().parseFromString(data.html, "text/html")

      // アンサーちゃんのHTML部分のみを取得して追加
      const answerChanHtml = doc.querySelector("#answerChan")
      if (answerChanHtml) {
        ref.current.appendChild(answerChanHtml)
      }
      // scriptタグは一部書換えが必要なため動的に生成して追加しています
      doc.querySelectorAll("script")?.forEach((script) => {
        const newScript = document.createElement("script")
        // answerChanConfigに追加プロパティを設定
        if (script.textContent && script.textContent.includes("answerChanConfig")) {
          newScript.textContent = `${script.textContent}; window.answerChanConfig.dynamicScript = true;
          `
        }
        if (script.src) {
          newScript.src = script.src
        }
        newScript.defer = script.defer
        ref.current?.appendChild(newScript)
      })
    }
  }, [data])
  // 非推奨なのは承知の上で、極力静的サイトのCSS定義を流用したいため<link>タグをコンポーネント内に記述しています
  // ※初期表示時にスタイルが適用されるようにするために前もって<link>タグを読み込んでおく必要があります
  return process.env.NODE_ENV === "production" ? (
    <>
      <div css={styles.wrapper} ref={ref} />
      {/* eslint-disable-next-line @next/next/no-css-tags */}
      <link rel="stylesheet" href="/css/answer_chan.css" />
    </>
  ) : (
    <div css={styles.questionWrapper}>
      <Image src={questionIcon} alt="?" css={styles.questionIcon} />
    </div>
  )
}

export default AnswerChan

const styles = {
  /**
   * 静的サイトのグローバルスタイルを部分的に適用するためのスタイル
   */
  wrapper: css`
    li {
      list-style: none;
    }

    a {
      text-decoration: none;
    }

    #answerChan {
      z-index: 50;
    }
  `,
  questionWrapper: css`
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    right: 50px;
    bottom: 16px;
    width: 50px;
    height: 50px;
    background-color: #2faa3b;
    text-align: center;
    font-size: 20px;
    color: #05479b;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: rgba(0, 0, 0, 0.2) 0 4px 8px 0;
    transition: 0.1s linear;

    :hover {
      color: #f0e8e4;
    }
  `,
  questionIcon: css`
    position: absolute;
    width: 30px;
    height: 30px;
    transition: 0.2s linear;
  `,
}
